import { Trophy, ChevronLeft, ChevronRight, Flag } from 'lucide-react';
import { QCM_GREEN } from '../../utils/qcmTheme';

/**
 * Pilotage de la FIN de séance sur le téléphone : podium projeté, puis revue de
 * correction question par question.
 *
 * Écran purement présentationnel — les libellés et les charges viennent de
 * `etapeSeance.js`, qui est le miroir client de la table de transitions du
 * serveur. Ici on ne décide rien : on rend le geste qu'on nous donne.
 *
 * Le professeur ne voit pas la projection depuis son téléphone : le titre est
 * donc la seule chose qui lui dit où en est l'écran de la classe.
 *
 * Un seul bouton vert, toujours au même endroit, « Suivant » puis « Terminer »
 * sur la dernière carte (chantier jeton, 2026-09-04) : la clôture est un pas
 * comme les autres, elle se répare (la revue se rejoue depuis le PC). Aucune
 * confirmation. « Précédent » n'existe qu'en revue, à sa gauche.
 */
const PilotageFin = ({
  titre, etape, geste, precedent, isTransitioning, onEtape,
}) => {
  const enRevue = etape === 'revue';
  const terminal = geste?.charge?.etape === 'fin';

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-5 px-8 text-center text-white"
      style={{ background: '#0e1116' }}
    >
      <p className="text-[11px] font-bold uppercase" style={{ letterSpacing: '.14em', color: '#a9e8c9' }}>
        {enRevue ? 'Correction' : 'Fin de séance'}
      </p>

      {enRevue ? null : <Trophy size={40} style={{ color: '#f5c26b' }} />}

      <h1 className="font-black text-2xl" style={{ fontFamily: "'Archivo', 'Inter', system-ui, sans-serif" }}>
        {titre}
      </h1>

      <p className="text-sm leading-relaxed" style={{ color: '#aab3a8' }}>
        {enRevue
          ? "L'énoncé, la bonne réponse et le score de la classe sont sur l'écran projeté."
          : 'Le classement est sur l’écran projeté.'}
      </p>

      {/* Une seule rangée : « Précédent » (revue seulement, dès la deuxième
          carte) et le geste principal, vert, au même endroit du début à la fin. */}
      <div className="flex gap-2.5 w-full max-w-sm">
        {enRevue ? (
          <button
            type="button"
            onClick={() => (precedent ? onEtape(precedent.charge) : null)}
            disabled={!precedent || isTransitioning}
            className="flex-1 py-3.5 rounded-2xl font-bold text-[15px] text-white flex items-center justify-center gap-1.5 disabled:opacity-40"
            style={{ background: 'rgba(255,255,255,.13)', border: '1.5px solid rgba(255,255,255,.27)' }}
          >
            <ChevronLeft size={16} />
            Précédent
          </button>
        ) : null}
        {geste ? (
          <button
            type="button"
            onClick={() => onEtape(geste.charge)}
            disabled={isTransitioning}
            className="flex-1 py-3.5 rounded-2xl font-bold text-[15px] text-white flex items-center justify-center gap-1.5 disabled:opacity-60"
            style={{ background: QCM_GREEN }}
          >
            {terminal ? <Flag size={16} /> : null}
            {geste.libelle}
            {terminal ? null : <ChevronRight size={16} />}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default PilotageFin;
